<template>
<div>
        <div class="side columns">
        <h2>边坡自动化监测</h2>
        <div class="all">
          <p>
              山体及边坡的稳定是影响工程能否安全、环保和高效运行的主要因素之一,因此,做好山体滑坡治理和高边坡加固成为土方工程工作 的重中之重。为实时监测边坡，实时了解边坡情况，满足安全监测的快速反馈和远程管理，实现边坡监测无人值守自动化。
          </p>
        </div>
        <div class="brief_box">

            <div class="title_box row">
                <div class="blue_line"></div>
                <h5>项目基本情况</h5>
            </div>
            <p>监测边坡的主体结构形变、土体变化和支护受力状况，确保边坡 稳定支护安全。</p>
             
              <div class="title_box row">
                <div class="blue_line"></div>
                <h5>监测参数</h5>
            </div>
            <p>地表位移（GNSS/测量机器人）</p>
            <p>深部位移（多点位移计）</p>
            <p>土体受力（土压力计）</p>
            <p>土体位移（土位移计）</p>
            <p>挡土墙变形（GNSS/测量机器人/倾斜仪）</p>
            <p>挡土墙受力（锚杆计/应力计）</p>
            <p>空隙水压力（扬压力计）</p>
            <p>气象环境（气象站）</p>
            <p>地震（加速度计）</p>

            <div class="title_box row">
                <div class="blue_line"></div>
                <h5>推荐设备</h5>
            </div>
            <p>监测设备：</p>
            <p>RocBox RT2000-GS北斗监测GNSS</p>
            <p>RT2000-GA005监测天线</p>
            <p>Topcon MS系列测量机器人</p>
            <p>Topcon DS系列测量机器人</p>
            <p>RT-VW-4300振弦式多点位移计</p>
            <p>RT-VW-2400振弦式土压力计</p>
            <p>RT-DT-6300测斜仪</p>
            <p>RT-VW-3100振弦式渗压计</p>
            <p>RT-DT-8100系列多参数气象站</p>
            <p>低频测振传感器</p>
            
            <h6>监测终端:</h6>
            <p>RocBox RT2000监测终端</p> 
            <p>RocMIoT监测物联网系列产品</p>  
            <p>振动信号采集仪</p>                
        </div>    
    </div>
     <foot></foot>

</div>

</template>
<style>
.side {
  width: 100%;
  background-color: rgba(245, 245, 245, 1);
}
h2 {
  font-size: 0.36rem;
  font-family: MicrosoftYaHei;
  font-weight: 400;
  color: rgba(37, 43, 58, 1);
  margin-top: 0.55rem;
  margin-bottom: 0.36rem;
}
.all {
  width: 11.4rem;
  height: 0.4rem;
  background: rgba(255, 255, 255, 1);
  border: 0.01rem solid rgba(221, 221, 221, 1);
  margin: 0 auto;
  padding: 0.3rem;
  font-size: 0.14rem;
  font-family: MicrosoftYaHei;
  font-weight: 400;
  color: rgba(102, 106, 117, 1);
}
.brief_box {
  width: 12rem;
  background: rgba(255, 255, 255, 1);
  border: 0.01rem solid rgba(221, 221, 221, 1);
  margin-top: 0.2rem;
  margin-bottom: 0.67rem;
  padding-bottom: .64rem;
}
.brief_box p,
 .brief_box h6{
  font-size: 0.14rem;
  font-family: MicrosoftYaHei;
  font-weight: 400;
  color: rgba(102, 106, 117, 1);
  padding-left: 0.4rem;
  padding-top: 0.1rem;
}
.brief_box h6{
    padding-top: .3rem;
}
.title_box {
  margin-left: 0.4rem;
  margin-top: 0.37rem;
  font-size: 0.16rem;
  font-family: MicrosoftYaHei;
  font-weight: 400;
  color: rgba(37, 43, 58, 1);
  line-height: 0.2rem;
}
.blue_line {
  width: 0.03rem;
  height: 0.2rem;
  background: rgba(67, 148, 208, 1);
  margin-right: 0.1rem;
}
</style>

<script>
import footer from "../../common/footer";
export default {
  data() {
    return {};
  },
  components: {
    foot: footer
  }
};
</script>





// WEBPACK FOOTER //
// src/homepages/solutionpage/side.vue